





















































































































import Vue from "vue";
import coreApiClient from "@/services/apis/coreApiClient";
import PhoneOtpDialog from "@/components/PhoneOtpDialog.vue";

export default Vue.extend({
  components: {
    PhoneOtpDialog
  },
  data() {
    return {
      valid: false,
      dataLoading: false,
      loading: false,
      error: "",
      ruleRequired: (value) => !!value || this.$t("REQUIRED"),
      data: {} as any,
      originalPhone: "",
      showOtpDialog: false,
      newPhoneNumber: "",
    };
  },
  async created() {
    this.dataLoading = true;
    this.data = await coreApiClient.callRaw("auth", "getProfile");
    this.originalPhone = this.data.phone || "";
    this.dataLoading = false;
  },
  methods: {
    async submit() {
      this.error = "";
      this.loading = true;
      try {
        const response = await coreApiClient.callRaw("auth", "updateProfile", undefined, this.data);
        
        if (response && typeof response === "object") {
          if (response.updateTypes && response.updateTypes.includes("phone_pending") && 
              response.nextAction === "verify_phone") {
            this.newPhoneNumber = this.data.phone;
            this.showOtpDialog = true;
            this.loading = false;
            return;
          }
          
          if (response.profile) {
            alert("Profile Updated Successfully");
            location.reload();
          }
        } else if (response) {
          alert("Profile Updated Successfully");
          location.reload();
        }
      } catch (err) {
        this.error = (err as any).message || err;
      } finally {
        this.loading = false;
      }
    },
    
    onPhoneVerified() {
      alert("Phone number updated successfully!");
      location.reload();
    },
    
    onOtpDialogClose() {
      this.data.phone = this.originalPhone;
      this.showOtpDialog = false;
    },
  },
});
